/**
 * Safely extract an error message string from an Axios error.
 * Handles both string detail (FastAPI HTTPException) and array detail
 * (Pydantic validation errors: [{type, loc, msg, input, ctx}]) — a raw
 * array/object detail rendered as a React child crashes with error #31,
 * so every caller must go through this instead of reading
 * error.response.data.detail directly.
 */
export const extractErrorMessage = (error, fallback = 'An error occurred.') => {
  const detail = error?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail
      .map((d) => (d && typeof d === 'object' && d.msg) ? d.msg : String(d))
      .filter(Boolean);
    return messages.length > 0 ? messages.join('; ') : fallback;
  }
  return fallback;
};
